"use client";

import cx from "classnames";
import React from "react";
import {
    useRef,
    useEffect,
    useState,
    useCallback,
    memo,
} from "react";
import { useRouter, usePathname } from "next/navigation";
import { toast } from "sonner";
import { useLocalStorage, useWindowSize } from "usehooks-ts";
import {
    setIsTransparentLoading,
    setIsGeneratingWebsite,
    setUser_ai_limit
} from "@/store/mainSlice";
import { ArrowUpIcon, PaperclipIcon, StopIcon, ImageIcon } from "./icons";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Mic, CircleAlert, Square } from "lucide-react";
import { useScrollToBottom } from "@/hooks/use-scroll-to-bottom";
import { useArtifact } from "@/hooks/use-artifact";
import BuyCreditsModal from "./BuyCreditsModal";
import { extractJSON } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";
import { useSelector, useDispatch } from "react-redux";
import { SuggestedActions } from "@/components/suggested-actions";
import axios from "axios";
import { setHtmlContentNew, setActiveNavItem, setForStreamingHtml, setActiveTab } from "@/store/mainSlice";
import { isDocumentType } from "@/lib/dropDownData";


function PureMultimodalInput({
    chatId,
    input,
    setInput,
    status,
    stop,
    messages,
    setMessages,
    sendMessage,
    className,
    selectedVisibilityType,
    htmlContent,
    setHtmlContent,
    setIsSaveHtmlToDb,
    screenId,
    isFollowUp,
    setIsFollowUp,
    // userDetail,
    aiLimit,
    remainingCredits,
    // remainingWords,
    // isFreeLimit,
    setRemainingCredits,
    setCreditsUsedParent,
    setUploadImage
}) {
    const textareaRef = useRef(null);
    const recognitionRef = useRef(null);
    const pathname = usePathname();
    const { width } = useWindowSize();
    const { setArtifact, artifact } = useArtifact();
    const [isStreaming, setIsStreaming] = useState(false);
    const [isListening, setIsListening] = useState(false);
    const dispatch = useDispatch();
    const { isGeneratingWebsite, user_ai_limit, isCodeView, userData, activeTab } = useSelector((state) => state.main);
    const [redesignPrompt, setRedesignPrompt] = useState("");
    const [generateWebsitesLoading, setGenerateWebsitesLoading] = useState(false);
    const [uploadedImage, setUploadedImage] = useState(null);
    const [uploadedImage2, setUploadedImage2] = useState(null);
    const [base64Image, setBase64Image] = useState("");
      const isProjectPage = pathname.startsWith("/project");
 const effectiveTab = isProjectPage ? activeTab : activeTab ?? "Page Builder";

    useEffect(() => {
        // 🧹 Reset textarea height when artifact closes
        if (!artifact?.isVisible && textareaRef.current) {
            textareaRef.current.style.height = "auto";
        }
    }, [artifact?.isVisible]);

    const handleImageUpload = (file) => {
        const imageUrl = URL.createObjectURL(file);
        // console.log("imageUrlimageUrlimageUrl", imageUrl)
        setUploadImage(file)
        setUploadedImage(imageUrl)
    };


    useEffect(() => {
        // console.log("uploadedImageuploadedImageuploadedImage-33", uploadedImage)
        async function convertBlobUrlToBase64() {
            if (uploadedImage) {
                try {
                    const response = await fetch(uploadedImage); // Fetch blob from blob URL
                    const blob = await response.blob(); // Convert response to Blob
                    const reader = new FileReader();

                    reader.onloadend = () => {
                        const base64String = reader.result;
                        setBase64Image(base64String); // Store Base64 string
                    };

                    reader.readAsDataURL(blob);
                } catch (error) {
                    console.error("Error converting blob URL to base64:", error);
                }
            } else {
                setBase64Image("");
            }
        }

        convertBlobUrlToBase64();
    }, [uploadedImage]);

    useEffect(() => {
        setInput("")
    }, [effectiveTab])

    const adjustHeight = () => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto";
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight + 2}px`;
        }
    };

    const resetHeight = () => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto";
            // textareaRef.current.style.height = "auto";
        }
    };
    const [localStorageInput, setLocalStorageInput] = useLocalStorage(
        "input",
        ""
    );
    const [wordCount, setWordCount] = useState(0);
    const [creditsUsed, setCreditsUsed] = useState(0);
    useEffect(() => {
        if (textareaRef.current) {
            const domValue = textareaRef.current.value;
            const finalValue = domValue || localStorageInput || "";
            setInput(finalValue);
            adjustHeight();
        }

        setInput("");
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto";
        }
    }, []);

    useEffect(() => {
        setLocalStorageInput(input);
    }, [input, setLocalStorageInput]);

    function updateCredits(text, redesignMarkdown) {
        const words = text.trim().split(/\s+/).filter(Boolean).length;
        const hasText = text.trim().length > 0;
        const credits = redesignMarkdown ? 5 : (hasText ? 1 : 0);
        setCreditsUsed(credits);
        // console.log(credits, "----creditscreditscreditscredits")
        if (setCreditsUsedParent) setCreditsUsedParent(credits);
        setWordCount(words);

        const creditsLeftNow = Math.max(aiLimit - credits, 0);
        setRemainingCredits(creditsLeftNow);
    }
    const handleInput = (event) => {
        const text = event.target.value;
        setInput(text);
        // console.log(text, "----texttexttexttexttexttexttext")
        updateCredits(text);
        adjustHeight();
    };

    useEffect(() => {
        const SpeechRecognition =
            window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            console.error("SpeechRecognition not supported in this browser");
            return;
        }

        const recognition = new SpeechRecognition();
        recognition.lang = "en-US";
        recognition.interimResults = true;
        recognition.continuous = true;

        recognition.onresult = (event) => {
            let finalTranscript = "";
            let interimTranscript = "";

            for (let i = event.resultIndex; i < event.results.length; i++) {
                const result = event.results[i];
                if (result.isFinal) {
                    finalTranscript += result[0].transcript + " ";
                } else {
                    interimTranscript += result[0].transcript;
                }
            }

            // Append final transcripts
            if (finalTranscript) {
                // setInput((prev) => prev + finalTranscript);
                setInput((prev) => {
                    const newText = prev + finalTranscript;
                    updateCredits(newText);
                    return newText;
                });
            }
        };

        recognition.onerror = (event) => {
            console.error("Speech recognition error:", event.error);
        };

        recognition.onend = () => {
            // console.log("Recognition ended");
            setIsListening(false); // only sets to false when user clicks stop
        };

        recognitionRef.current = recognition;
    }, []);


    const handleVoiceClick = () => {
        if (!recognitionRef.current) return;
        if (isListening) {
            recognitionRef.current.stop();
            setIsListening(false);
        } else {
            try {
                recognitionRef.current.start();
                setIsListening(true);
            } catch (error) {
                console.error("Speech recognition error:", error);
            }
        }
    };
    
    const fileInputRef = useRef(null);
    const [uploadQueue, setUploadQueue] = useState([]);
    const [prompt, setPrompt] = useState("");
    const [showModal, setShowModal] = useState(false);
    const isInputLocked = status !== "ready" || isGeneratingWebsite || isStreaming;
    // const isFreeLimitBool = isFreeLimit === true || isFreeLimit === "true";
    const htmlContentNew = useSelector((state) => state.html.htmlContent);
  let chatType = "chat";
  if (effectiveTab === "Card Maker") {
    chatType = "card_maker";
  } else if (effectiveTab === "Page Builder") {
    chatType = "page_builder";
  } else if (effectiveTab === "Go-to-Market Strategy") {
    chatType = "go_to_market_strategy";
  } else if (effectiveTab) {
    chatType = effectiveTab.toLowerCase().replace(/[\s\/]+/g, "_");
  }

    const parseStreamFailureJson = (text = "") => {
        const raw = String(text || "").trim();
        if (!raw || !raw.startsWith("{") || !raw.endsWith("}")) return null;
        try {
            const parsed = JSON.parse(raw);
            if (parsed && parsed.success === false) return parsed;
        } catch (e) { }
        return null;
    };

    const stripEmbeddedStreamErrors = (text = "") => {
        const raw = String(text || "");
        if (!raw) return { cleaned: raw, error: null };

        let cleaned = raw;
        let firstError = null;

        const objectCandidates = raw.match(/\{[^{}]{0,600}\}/g) || [];
        for (const cand of objectCandidates) {
            try {
                const parsed = JSON.parse(cand);
                if (parsed && parsed.success === false && parsed.error) {
                    if (!firstError) firstError = parsed;
                    cleaned = cleaned.replace(cand, "");
                }
            } catch (e) { }
        }

        if (!firstError && /\"success\"\s*:\s*false/i.test(raw) && /\"error\"\s*:/i.test(raw)) {
            firstError = { success: false, error: "Streaming failed." };
            cleaned = cleaned.replace(/\{[\s\S]*?\"success\"\s*:\s*false[\s\S]*?\}/gi, "");
        }

        return { cleaned, error: firstError };
    };

    const submitForm = useCallback(async () => {
        if (user_ai_limit < creditsUsed) {
            toast.error("Oops! You don't have enough credits to proceed. Please add more credits to continue.", {
                style: { color: "red" }, // only text color
                iconTheme: { primary: "red", secondary: "#fff" },
                position: "top-center",
            });
            setShowModal(true)
            return;
        }


        if (input.trim() === "") return;
        if (Number(creditsUsed) > Number(user_ai_limit)) {
            setShowModal(true)
            return;
        }
        if (userData.is_profile_complete === 0) {
            return;
        }
        setGenerateWebsitesLoading(true);

        // if (isStreaming) return;
        const userPrompt = chatType == "page_builder" ? input.replace("card", "website") : input;
        const effectiveFollowUp = isFollowUp || (chatType === "card_maker" && Boolean(htmlContentNew));
        const streamingId = Date.now().toString();
        const createdAt = new Date().toISOString();
        const isNewScreen = !screenId;
        const creditToDeduct = creditsUsed;

        // ✅ Open artifact overlay for preview
        setArtifact((prev) => ({
            ...prev,
            isVisible: true,
            status: "streaming",
            kind: isDocumentType(chatType) ? "text" : "html",
            title: chatType === "card_maker"
                    ? "Card Preview"
                    : chatType === "page_builder"
                        ? "Page Preview"
                        : `${effectiveTab} Preview`,
            content: "",
            // boundingBox: { top: 100, left: 100, width: 600, height: 400 },
            boundingBox: chatType === "card_maker"
                ? { top: 100, left: 100, width: 400, height: 300 }
                : { top: 100, left: 100, width: 600, height: 400 },
            showCode: false,
        }));

        setIsStreaming(true);
        dispatch(setIsGeneratingWebsite(true));
        setWordCount(0);
        setCreditsUsed(0);


        // User & Assistant placeholders
        setMessages((prev) => [
            ...prev,
            {
                id: `${streamingId}-user`,
                role: "user",
                parts: [
                    { type: "text", text: userPrompt, url: uploadedImage },
                    { type: "text", text: `** Credit Used: ${creditsUsed}**` },
                ],
                metadata: { createdAt },
            },
            {
                id: streamingId,
                role: "assistant",
                parts: [
                        {
                            type: "text",
                            text: effectiveFollowUp
                                ? "Varnz is editing your site — just a moment..."
                                : "Varnz is building your site — just a moment...",
                        },
                    { type: "data-html", data: "" },
                ],
                metadata: { createdAt },
            },
        ]);

        setLocalStorageInput("");
        resetHeight();
        setInput("");
        if (width && width > 768) textareaRef.current?.focus();

        try {
            if (!effectiveFollowUp) {
                dispatch(setHtmlContentNew(null));
                // console.log("setHtmlContentNew-44")

                setHtmlContent("");
                dispatch(setForStreamingHtml(""))
            }
           const url = effectiveFollowUp
                ? process.env.NEXT_PUBLIC_APP_VARNZ_EDIT_WEBSITE
                : process.env.NEXT_PUBLIC_APP_VARNZ_AI;

            // const encryptedHtml = encryptHtml(effectiveFollowUp ? htmlContentNew : htmlContent);
            const encryptedHtml = effectiveFollowUp ? htmlContentNew : htmlContent

            // console.log("Encrypted HTML (base64):", encryptedHtml);


            // console.log(base64Image, "uploadedImagebase64Imagebase64Image")
           const payload = effectiveFollowUp
                ? { previousPrompt: prompt, html: encryptedHtml, prompt: userPrompt, userId: userData._id, creditsUsed: creditsUsed, chat_type: chatType, }
                : { prompt: userPrompt, userId: userData._id, creditsUsed: creditsUsed, chat_type: chatType, redesignPrompt: redesignPrompt ? redesignPrompt : null, base64Image: base64Image };

            console.log("[builder][request] about to call API", {
                isFollowUp: effectiveFollowUp,
                url,
                method: "POST",
                chatType,
                promptLength: (userPrompt || "").length,
                hasHtml: Boolean(encryptedHtml),
                htmlLength: (encryptedHtml || "").length,
                userId: userData?._id,
                creditsUsed,
            });
            console.log("[builder][request][payload]", payload);

            let compressed;
            if (effectiveFollowUp) {
                dispatch(setIsTransparentLoading(true));
                compressed = payload;
            } else {
                compressed = payload;
                setIsSaveHtmlToDb(false);
            }
            // console.log(compressed, "------------------compressed")

            const response = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(compressed),

            });
            console.log("[builder][response] received", {
                url,
                status: response.status,
                ok: response.ok,
                redirected: response.redirected,
                contentType: response.headers.get("content-type"),
            });
            if (!response.ok) {
                let apiError = `Request failed: ${response.status}`;
                try {
                    const errPayload = await response.json();
                    apiError = errPayload?.error || errPayload?.message || apiError;
                } catch (e) { }
                throw new Error(apiError);
            }

            // Deduct credits only after AI endpoint responds successfully.
            try {
                const res = await axios.post(
                    process.env.NEXT_PUBLIC_APP_DEDUCT_CREDIT,
                    {
                        userId: userData._id,
                        creditUsed: creditToDeduct,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-auth-token": localStorage.getItem("authToken"),
                        },
                    }
                );
                dispatch(setUser_ai_limit(res.data.data.ai_limit))
            } catch (err) {
                console.error("Error deducting credits:", err.response?.data || err.message);
                toast.error("Failed to deduct credits. Please try again.", {
                    style: { color: "red" },
                    iconTheme: { primary: "red", secondary: "#fff" },
                    position: "top-center",
                });
                throw err;
            }

            if (!response.body) throw new Error("Response body is null.");
            if (effectiveFollowUp) {
                const result = await response.json();
                console.log("[builder][followup][result]", result);
                console.log("[builder][followup][result-summary]", {
                    success: result?.success,
                    hasHtml: Boolean(result?.html),
                    htmlLength: (result?.html || "").length,
                    fullMessageLength: (result?.fullMessage || "").length,
                    error: result?.error || null,
                });
                // if (chatType === "business_plan") {
                     if (isDocumentType(chatType)) {
                    if (result.success) {
                        const markdownContent =  result.html;

                        // update artifact preview
                        setArtifact((prev) => ({
                            ...prev,
                            content: markdownContent,
                            status: "idle",
                            kind: "text",
                        }));

                        // update redux states
                        setHtmlContent(markdownContent);
                        dispatch(setForStreamingHtml(markdownContent));
                        dispatch(setHtmlContentNew(markdownContent));
                        setIsSaveHtmlToDb(true);
                        dispatch(setIsTransparentLoading(false));
                        setMessages((prev) => [
                        ...prev,
                        {
                            id: `${streamingId}-user`,
                            role: "user",
                            parts: [
                                { type: "text", text: userPrompt},
                                {
                                    type: "text",
                                    text: `** Credit Used: ${creditsUsed}**`,
                                },
                            ],
                            metadata: { createdAt },
                        },
                        {
                            id: streamingId,
                            role: "assistant",
                            parts: [
                                {
                                    type: "text",
                                    text: `Your Document is updated! Take a look - If you have any updates, just type and will update it for you.`,
                                },
                                { type: "tool-createDocument", text: markdownContent || "" },
                            ],
                            metadata: { createdAt },
                        },
                    ]);
                        toast.success("Your Document is updated!", { style: { color: "green" },
                        iconTheme: { primary: "green", secondary: "#fff" }, position: "top-center" });
                        return;
                    } else {
                        toast.error(result.error || "Failed to update Document", {
                            style: { color: "red" },
                        iconTheme: { primary: "red", secondary: "#fff" },
                            position: "top-center",
                        });
                        return;
                    }
                }
                if (result.success) {
                    // let decryptedHtml = decryptHtml(result.html)
                    let decryptedHtml = result.html

                    setHtmlContent(decryptedHtml);
                    dispatch(setForStreamingHtml(decryptedHtml));


                    dispatch(setHtmlContentNew(decryptedHtml));
                    // console.log("setHtmlContentNew-55")


                    // console.log("---result.html-----", result.html);
                    setIsSaveHtmlToDb(true);
                    // alert()
                    setMessages((prev) => [
                        ...prev,
                        {
                            id: `${streamingId}-user`,
                            role: "user",
                            parts: [
                                { type: "text", text: userPrompt, url: uploadedImage },
                                {
                                    type: "text",
                                    text: `** Credit Used: ${creditsUsed}**`,
                                },
                            ],
                            metadata: { createdAt },
                        },
                        {
                            id: streamingId,
                            role: "assistant",
                            parts: [
                                {
                                    type: "text",
                                    text: `Your ${chatType == "card_maker" ? 'Card' : 'Web Page'} is ready! Take a look - If you have any updates, just type and will update it for you.`,
                                },
                                { type: "data-html", data: decryptedHtml || "" },
                            ],
                            metadata: { createdAt },
                        },
                    ]);

                    toast.success(activeTab === "Card Maker" ? 'Your Card is ready!' : "Your Web Page is ready!", {
                        style: { color: "green" }, // only text color
                        iconTheme: { primary: "green", secondary: "#fff" },
                        position: "top-center",
                    });
                    // alert(1)

                    setInput("");
                    dispatch(setIsTransparentLoading(false));
                    setArtifact((prev) => ({ ...prev, status: "idle" }));
                    return;
                } else {
                    toast.error(result.error, {
                        style: { color: "red" }, // only text color
                        iconTheme: { primary: "red", secondary: "#fff" },
                        position: "top-center",
                    });
                    // window.location.assign("/")
                    console.error("❌ API Error:", result.error, result);
                }
            }
console.log(response, "---=========responseresponseresponseresponse")
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let fullHtml = "";
            let started = false; // Only begin rendering after <!DOCTYPE html>
            let buffer = ""; // to handle partial doctype
            let extractedData = null;
            let htmlForJson = "";
            let isAdd = true;
            const findHtmlStartIndex = (text) => {
                if (!text) return -1;
                const lower = String(text).toLowerCase();
                let idx = lower.indexOf("<!doctype html");
                if (idx !== -1) return idx;
                idx = lower.indexOf("<html");
                if (idx !== -1) return idx;
                return -1;
            };
            const isGrpIndexObject = (obj) => {
                if (!obj || typeof obj !== "object") return false;
                const keys = Object.keys(obj);
                if (!keys.some((k) => /^GRP\d+$/i.test(k))) return false;
                return keys
                    .filter((k) => /^GRP\d+$/i.test(k))
                    .every((k) => obj?.[k] && typeof obj[k] === "object" && typeof obj[k].name === "string");
            };
            const withDisabledLinksStyle = (html) => {
                const styleBlock = `<style>
     a {
       pointer-events: none !important;
       cursor: default !important;
       text-decoration: none !important;
       color: inherit !important;
     }
   </style>`;
                if (/<\/head>/i.test(html)) return String(html).replace(/<\/head>/i, `${styleBlock}</head>`);
                return String(html).replace(/<body[^>]*>/i, (m) => `${m}${styleBlock}`);
            };
            // 🧠 Handle Business Plan responses separately (Markdown → HTML)
        //  if (chatType === "business_plan") {
             if (isDocumentType(chatType)) {
  let markdownContent = "";

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    const chunk = decoder.decode(value, { stream: true });
    markdownContent += chunk;

    // 🔥 Update the artifact content in real-time
    setArtifact((prev) => ({
      ...prev,
      content: markdownContent,
      status: "streaming",
      kind: "text",
    }));

    // 🔥 Also update Redux for live reactivity (if artifact view reads from it)
    dispatch(setForStreamingHtml(markdownContent));
  }

  // ✅ Once streaming completes
  setHtmlContent(markdownContent);
  dispatch(setHtmlContentNew(markdownContent));
  setIsSaveHtmlToDb(true);
  setIsStreaming(false);
  setArtifact((prev) => ({ ...prev, status: "idle" }));

  toast.success("Your Document Plan is ready!", { style: { color: "green" },
                        iconTheme: { primary: "green", secondary: "#fff" },position: "top-center" });
  return;
}


            while (true) {
                const { done, value } = await reader.read();
                if (done) {
                    const isCard = chatType === "card_maker";
                    if (chatType === "card_maker") {
                        // Cards are simple HTML snippets
                        // setHtmlContent(prev => prev + htmlForJson);
                        setHtmlContent((prev) => {
                            let data = htmlForJson

                            // console.log(htmlForJson, "htmlForJsonhtmlForJson", data)

                            dispatch(setForStreamingHtml(data))
                            return data
                        });
                        dispatch(setHtmlContentNew(htmlForJson));
                        setIsFollowUp(true);
                        // console.log("setHtmlContentNew-66")


                        setIsSaveHtmlToDb(true);
                        setMessages((prev) =>
                            prev.map((m) =>
                                m.id === streamingId
                                    ? {
                                        ...m,
                                        parts: [
                                            { type: "text", text: "Your Card is ready!" },
                                            { type: "data-html", data: htmlForJson },
                                        ],
                                    }
                                    : m
                            )
                        );
                        toast.success("Your Card is ready!", { position: "top-center" });
                        // alert(2)
                        break;
                    } else {
                        if (!started && buffer) {
                            const startIndex = findHtmlStartIndex(buffer);
                            fullHtml = startIndex !== -1 ? buffer.slice(startIndex) : buffer;
                        }

                        const parser = new DOMParser();
                        const doc = parser.parseFromString(fullHtml, "text/html");

                        // ✅ Extract JSON + reRunBuildWebsites
                        extractedData = extractJSON(htmlForJson);
                        // console.log(extractedData, "extractedData-test-1");
                        if (isGrpIndexObject(extractedData)) {
                            const keys = Object.keys(extractedData); // Get all keys
                            const lastKey = keys[keys.length - 1]; // Get last key

                            const incompleteBanner = fullHtml.includes("Website generation did not finish");
                            if (!incompleteBanner) {
                                for (let key in extractedData) {
                                    if (key !== "GRP1") {
                                        const updatedHtml = await reRunBuildWebsites(
                                            extractedData[key].name,
                                            lastKey == key,
                                            extractedData,
                                            key,
                                            fullHtml = fullHtml
                                        );
                                        fullHtml = updatedHtml;
                                    }
                                }
                            }
                        }
                        let finalHtml = String(fullHtml || "");
                        if (!/<\/html>/i.test(finalHtml)) finalHtml = `${finalHtml}</body></html>`;
                        finalHtml = finalHtml.replace(/<\/body>\s*<\/html>/i, "</body></html>");
                        setHtmlContent(finalHtml);
                        dispatch(setForStreamingHtml(finalHtml));
                        dispatch(setHtmlContentNew(finalHtml));


                        setInput("");
                        //  Save only after everything is done
                        setIsSaveHtmlToDb(true);
                        //  Replace placeholder assistant message
                        setIsFollowUp(true);
                        setMessages((prev) =>
                            prev.map((m) =>
                                m.id === streamingId
                                    ? {
                                        ...m,
                                        parts: [
                                            {
                                                type: "text",
                                                text: `Your ${chatType == "card_maker" ? "Card" : "Web Page"} is ready! Take a look - If you have any updates, just type and will update it for you.`,
                                            },
                                            { type: "data-html", data: finalHtml || "" },
                                        ],
                                    }
                                    : m
                            )
                        );
                        // console.log("setHtmlContentNew-77")

                        // console.log("test-2", fullHtml, "klkllllllll")
                        toast.success(activeTab === "Card Maker" ? 'Your Card is ready!' : "Your Web Page is ready!", {
                            style: { color: "green" }, // only text color
                            iconTheme: { primary: "green", secondary: "#fff" },
                            position: "top-center",
                        });
                        // alert(3)
                        break;
                    }
                }

                let chunk = decoder.decode(value, { stream: true });
                const embedded = stripEmbeddedStreamErrors(chunk);
                chunk = embedded.cleaned;
                const streamErr = embedded.error || parseStreamFailureJson(chunk);
                if (streamErr) {
                    setInput("");
                    toast.error(streamErr.error || "Streaming failed.", {
                        style: { color: "red" },
                        iconTheme: { primary: "red", secondary: "#fff" },
                        position: "top-center",
                    });
                    break;
                }

                htmlForJson += chunk;

                // ✅ If first chunk is an error JSON: { success: false, error: ... }
                if (!started && chunk.trim().startsWith("{")) {
                    try {
                        const parsed = JSON.parse(chunk);
                        if (parsed.success === false) {
                            setInput("");
                            setMessages((prev) =>
                                prev.map((m) =>
                                    m.id === streamingId
                                        ? {
                                            ...m,
                                            parts: [
                                                {
                                                    type: "text",
                                                    text: "Your website is give some error. 🎉",
                                                },
                                                { type: "data-html", data: fullHtml },
                                            ],
                                        }
                                        : m
                                )
                            );
                            break; 
                        }
                    } catch (err) { }
                }

                if (!started) {
                    buffer += chunk;
                    extractedData = extractJSON(buffer);
                    // console.log(extractedData, "extractedData-test-2", buffer);
                    const startIndex = findHtmlStartIndex(buffer);
                    if (startIndex !== -1) {
                        const sliced = buffer.slice(startIndex);
                        started = true;
                        fullHtml += sliced;
                        setHtmlContent((prev) => {
                            let data = prev + sliced
                            dispatch(setForStreamingHtml(data))
                            return data
                        });

                        buffer = "";
                    }
                } else {
                    const htmlEndIndex = chunk.toLowerCase().indexOf("</html>");
                    const extraText = chunk.indexOf("```");
                    if (htmlEndIndex !== -1) {
                        const sliced = chunk.slice(0, htmlEndIndex + 7);
                        fullHtml += sliced;
                        setHtmlContent((prev) => {
                            const data = prev + sliced;
                            dispatch(setForStreamingHtml(data));
                            return data;
                        });


                        // ✅ Update meta tags exactly like React
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(fullHtml, "text/html");
                        let head = doc.querySelector("head");
                        if (!head) {
                            head = doc.createElement("head");
                            doc.documentElement.insertBefore(head, doc.body);
                        }
                        // ✅ Inline reRunBuildWebsites logic
                        if (isGrpIndexObject(extractedData)) {
                            const keys = Object.keys(extractedData);
                            // console.log(keys, "keyskeyskeys", extractedData);
                            const lastKey = keys[keys.length - 1];
                            for (let key in extractedData) {
                                // console.log(key, ":", extractedData[key].name);
                                if (key !== "GRP1") {
                                    if (lastKey == key) {
                                        const updatedHtml = await reRunBuildWebsites(
                                            extractedData[key].name,
                                            true,
                                            extractedData,
                                            key,
                                            fullHtml = fullHtml
                                        );
                                        fullHtml = updatedHtml;
                                    } else {
                                        const updatedHtml = await reRunBuildWebsites(
                                            extractedData[key].name,
                                            false,
                                            extractedData,
                                            key,
                                            fullHtml = fullHtml
                                        );
                                        fullHtml = updatedHtml;
                                    }
                                }
                            }
                        }
                        let finalHtml = String(fullHtml || "");
                        if (!/<\/html>/i.test(finalHtml)) finalHtml = `${finalHtml}</body></html>`;
                        finalHtml = finalHtml.replace(/<\/body>\s*<\/html>/i, "</body></html>");
                        setHtmlContent(finalHtml);
                        dispatch(setForStreamingHtml(finalHtml));
                        dispatch(setHtmlContentNew(finalHtml));
                        setMessages((prev) =>
                            prev.map((m) =>
                                m.id === streamingId
                                    ? {
                                        ...m,
                                        parts: [
                                            {
                                                type: "text",
                                                text: `Your ${chatType == "card_maker" ? "Card" : "Web Page"} is ready! Take a look - If you have any updates, just type and will update it for you.`,
                                            },
                                            { type: "data-html", data: finalHtml || "" },
                                        ],
                                    }
                                    : m
                            )
                        );
                        // console.log("setHtmlContentNew-88")


                        toast.success(activeTab === "Card Maker" ? 'Your Card is ready!' : "Your Web Page is ready!", {
                            style: { color: "green" }, // only text color
                            position: "top-center",
                            iconTheme: { primary: "green", secondary: "#fff" },
                        });
                        // alert(5)

                        setInput("");
                        setIsSaveHtmlToDb(true);
                        setIsFollowUp(true);
                        break;
                    } else {
                        if (extraText !== -1) {
                            const sliced = chunk.slice(0, extraText);
                            fullHtml += sliced;
                            if (isAdd) {
                                setHtmlContent((prev) => {
                                    let updated = prev + sliced
                                    // dispatch(setForStreamingHtml(updated))
                                    setTimeout(() => {
                                        dispatch(setForStreamingHtml(updated));
                                    }, 0);

                                    return updated
                                });

                            }
                            isAdd = false;
                        } else {
                            if (isAdd) {
                                fullHtml += chunk;
                                setHtmlContent((prev) => {
                                    let data = prev + chunk
                                    dispatch(setForStreamingHtml(data))
                                    return data
                                });
                            }
                        }
                    }
                }
            }
            setArtifact((prev) => ({ ...prev, status: "idle" }));
        } catch (err) {
            console.error("Error generating website:", err);
            setMessages((prev) =>
                prev.map((m) =>
                    m.id === streamingId
                        ? {
                            ...m,
                            parts: [
                                {
                                    type: "text",
                                    text: "Oops, something went wrong. Please try again.",
                                },
                            ],
                        }
                        : m
                )
            );
        } finally {
            setIsStreaming(false);
            dispatch(setIsGeneratingWebsite(false));
        }
    }, [
        input,
        isStreaming,
        userData,
        width,
        screenId,
        remainingCredits,
        isFollowUp,
        prompt,
        htmlContent,
        htmlContentNew,
        creditsUsed,
        user_ai_limit,
        effectiveTab
    ]);

    const reRunBuildWebsites = async (
        grpPrompt,
        isLastKey = false,
        extractedData,
        key,
        fullHtml
    ) => {
        try {
            // console.log("reRunBuildWebsites called with:", key, extractedData);

            const url = process.env.NEXT_PUBLIC_APP_VARNZ_AI;
            const stripSnippetWrappers = (snippet = "") =>
                String(snippet || "")
                    .replace(/<!--\s*START\s*GRP\d+\s*-->/gi, "")
                    .replace(/<!--\s*END\s*GRP\d+\s*-->/gi, "")
                    .replace(/&lt;!--\s*START\s*GRP\d+\s*--&gt;/gi, "")
                    .replace(/&lt;!--\s*END\s*GRP\d+\s*--&gt;/gi, "")
                    .trim();

            const insertBeforeBodyClose = (html = "", snippet = "") => {
                const base = String(html || "");
                const clean = stripSnippetWrappers(snippet);
                if (!clean) return base;

                const lower = base.toLowerCase();
                const bodyIdx = lower.lastIndexOf("</body>");
                if (bodyIdx !== -1) {
                    return `${base.slice(0, bodyIdx)}\n${clean}\n${base.slice(bodyIdx)}`;
                }
                const htmlIdx = lower.lastIndexOf("</html>");
                if (htmlIdx !== -1) {
                    return `${base.slice(0, htmlIdx)}\n${clean}\n${base.slice(htmlIdx)}`;
                }
                return `${base}\n${clean}`;
            };

            const instruction = `Project brief:\n${redesignPrompt || input}
${redesignPrompt
                    ? `use image that are provided in the markdown image used is important to the redesign.`
                    : ""
                }
We already agreed on these GRPs:
${JSON.stringify(extractedData, null, 2)}

Now output ONLY ${key} (${grpPrompt}) as a concatenable HTML snippet (no <html>/<head>/<body>, no explanations).
Continue the exact same design system (fonts, spacing, colors).
Wrap strictly with:
<!-- START ${key} -->
...
<!-- END ${key} -->`;

            const response = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    prompt: instruction,
                    isRebuild: true,
                    isLastKey,
                    base64Image: base64Image,
                }),
            });

            if (!response.ok) {
                let apiError = `Rebuild failed: ${response.status}`;
                try {
                    const errPayload = await response.json();
                    apiError = errPayload?.error || errPayload?.message || apiError;
                } catch (e) { }
                console.error(apiError);
                return fullHtml;
            }

            if (!response.body) {
                console.error("No response body from API");
                return;
            }

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let snippet = "";

            while (true) {
                const { done, value } = await reader.read();
                if (done) {
                    // console.log("Rerun done");
                    break; // ✅ Prevent infinite loop
                }

                let chunk = decoder.decode(value, { stream: true });
                const embedded = stripEmbeddedStreamErrors(chunk);
                chunk = embedded.cleaned;
                const streamErr = embedded.error || parseStreamFailureJson(chunk);
                if (streamErr) {
                    console.error("reRunBuildWebsites stream error:", streamErr.error || streamErr);
                    break;
                }
                snippet += chunk;

            }

            const merged = insertBeforeBodyClose(fullHtml, snippet);
            setHtmlContent(merged);
            dispatch(setForStreamingHtml(merged));
            return merged;
            // console.log("Final HTML length:", fullHtml.length);
        } catch (error) {
            return fullHtml;
            console.error("Error in reRunBuildWebsites:", error);
        }
    };

    useEffect(() => {
        if (screenId) {
            setIsFollowUp(true);
        }
    }, [screenId]);

    const { isAtBottom, scrollToBottom } = useScrollToBottom();

    useEffect(() => {
        if (status === "submitted") {
            scrollToBottom();
        }
    }, [status, scrollToBottom]);

    useEffect(() => {
        const explorePrompt = localStorage.getItem("explorePrompt");
        const redesignMarkdown = localStorage.getItem("redesign_markdown");
        if (redesignMarkdown) {
            setRedesignPrompt(redesignMarkdown);
            localStorage.setItem("redesign_pending", "1");
            // Rebuild/redesign should always run as Page Builder
            dispatch(setActiveTab("Page Builder"));
        }
        if (explorePrompt) {
            setInput(explorePrompt); // show in textarea
            updateCredits(explorePrompt, redesignMarkdown); // update credits
            requestAnimationFrame(adjustHeight);
            setTimeout(() => {
                submitForm(explorePrompt); // pass prompt directly
                localStorage.removeItem("explorePrompt"); // cleanup AFTER submit
                localStorage.removeItem("redesign_markdown");
            }, 0);
        }
    }, [submitForm]);


    // const assistantMessage = messages.find((m) => m.role === "assistant");
    // const hasBuiltHtml =
    //     assistantMessage &&
    //     assistantMessage.parts?.some(
    //         (p) => p.type === "data-html" && p.data && p.data.trim() !== ""
    //     );

    // if (!artifact.isVisible && !hasBuiltHtml) {
    //     return null;
    // }

    return (
        <>
            <div className="relative w-full flex flex-col gap-4 rounded-2xl !text-base bg-muted py-4 dark:border-zinc-700 h-auto py-[14px] px-[22px] rounded-[28px] overflow-hidden overflow-y-auto">

                {/* 🖼️ Image Preview (optional) */}
                {uploadedImage && chatType === "page_builder" && !isFollowUp && screenId == null && !artifact.isVisible && (
                    <div className="absolute left-2 top-2">
                        <div className="relative w-12 h-12">
                            <img
                                src={uploadedImage}
                                alt="Preview test"
                                className="w-full h-full object-cover rounded-lg border border-zinc-300"
                            />

                            {/* ❌ Cross (delete) button */}
                            <button
                                onClick={() => {
                                    setUploadedImage(null); // remove preview
                                    setBase64Image("");     // optional, if you’re storing base64
                                }}
                                className="absolute -top-2 -right-2 bg-black text-white rounded-full p-[2px] hover:bg-red-500 transition"
                                title="Remove image"
                            >
                                ✕
                            </button>
                        </div>
                    </div>
                )}
                <div className="flex items-center gap-3">
                    {/* 🖼️ Image Upload Button - LEFT SIDE */}
                    {
                        false && chatType === "page_builder" && !isFollowUp && screenId == null && !artifact.isVisible && (
                            <label
                                htmlFor="image-upload"
                                // className="upload_image_label rounded-full p-2 h-fit border dark:border-zinc-600 cursor-pointer transition-colors duration-200 !bg-white !text-black hover:!bg-black hover:!text-white"
                                className="rounded-full p-2 h-fit border dark:border-zinc-600 cursor-pointer transition-colors duration-200 !bg-white !text-black hover:!bg-black hover:!text-white"

                                title="Attach an image"
                            >
                                <input
                                    id="image-upload"
                                    type="file"
                                    accept="image/*"
                                    className="hidden"
                                    onChange={(e) => {
                                        const file = e.target.files?.[0];
                                        if (file) handleImageUpload(file);
                                    }}
                                />
                                <ImageIcon size={16} />
                            </label>
                        )
                    }


                    {/* 📝 Text Input */}
                    <Textarea
                        data-testid="multimodal-input"
                        ref={textareaRef}
                        placeholder="Write your prompt..."
                        value={input}
                        onChange={handleInput}
                        disabled={isInputLocked || isCodeView}
                        // disabled={(isGeneratingWebsite || isStreaming || isCodeView) && artifact?.isVisible}
                        className={cx(
                            "min-h-[24px] max-h-[220px] bg-[transparent] p-0 border-0 resize-none focus-visible:ring-0 focus-visible:shadow-none focus-visible:outline-none outline-none shadow-none h-auto md:leading-[27px] pr-7 flex-1",
                            // "text_lll min-h-[24px] h-full max-h-[220px] md:max-h-[220px] max-h-[120px] bg-transparent p-0 border-0 resize-none focus-visible:ring-0 focus-visible:shadow-none focus-visible:outline-none outline-none shadow-none h-auto md:leading-[27px] pr-7 flex-1 overflow-y-auto",
                            //   "text_lll w-full min-h-[24px] h-full bg-transparent p-0 border-0 resize-none focus-visible:ring-0 focus-visible:shadow-none focus-visible:outline-none outline-none shadow-none md:leading-[27px] pr-7 flex-1",
                            //   "max-h-[120px] md:max-h-[220px] overflow-y-auto",
                            className
                        )}
                        rows={1}
                        autoFocus
                        onKeyDown={(event) => {
                            if (
                                event.key === "Enter" &&
                                !event.shiftKey &&
                                !event.nativeEvent.isComposing
                            ) {
                                event.preventDefault();

                                if (status !== "ready") {
                                    toast.error("Please wait for the model to finish its response!", {
                                        style: { color: "red" },
                                        position: "top-center",
                                    });
                                } else {
                                    submitForm();
                                }
                            }
                        }}
                    />

                    {/* 🎤 Voice + Send Buttons - RIGHT SIDE */}
                    <div className="flex flex-row items-center gap-1 footer_assets">
                        <button
                            type="button"
                            onClick={handleVoiceClick}
                            disabled={isInputLocked}
                            className={`rounded-full p-1.5 h-fit border dark:border-zinc-600 
                            ${isListening ? '!bg-red-500 !text-white' : '!bg-white !text-black hover:!bg-black hover:!text-white'} 
                            ${isInputLocked ? 'opacity-50 cursor-not-allowed' : ''}
                            cursor-pointer gap-2 transition-colors duration-200`}
                            title={isListening ? "Stop listening" : "Start voice input"}
                        >
                            {isListening ? <Square size={14} /> : <Mic size={14} />}
                        </button>

                        <SendButton
                            input={input}
                            submitForm={submitForm}
                            uploadQueue={uploadQueue}
                            disabled={isInputLocked}
                        />
                    </div>
                </div>
            </div>
            {/* <div className="text-token-text-secondary relative mt-2 flex min-h-8 w-full items-center justify-center p-2 text-center text-xs md:px-3">
                <div className="flex items-center">
                    Word count: &nbsp;<b> {wordCount}</b>&nbsp;• Credits required:&nbsp;
                    <b>
                        {creditsUsed}/{user_ai_limit}
                    </b>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <a className="text-token-text-primary decoration-token-text-primary cursor-pointer underline ml-2">
                                <CircleAlert size={16} />
                            </a>
                        </TooltipTrigger>
                        <TooltipContent align="center">
                            <p className="text-[12px] max-w-[260px]">
                                <span className="text-accent">⚡</span> Input of every{" "}
                                <b>50 words</b> costs <b>1 credit</b>. You have{" "}
                                <span className="text-emerald-400 dark:text-emerald-300 font-semibold">
                                    {user_ai_limit} credits
                                </span>{" "}
                                remaining (<b>{(process.env.NEXT_PUBLIC_APP_PER_CREDIT_WORD * user_ai_limit)} words</b> max).
                            </p>
                        </TooltipContent>
                    </Tooltip>
                </div>
            </div> */}

            {/* Suggested Actions */}
            {messages.length === 0 && !artifact?.isVisible && (
                <SuggestedActions
                    onSelect={(prompt) => {
                        setInput(prompt);
                        updateCredits(prompt);
                        requestAnimationFrame(adjustHeight);
                        setTimeout(() => submitForm(), 0);
                    }}
                />
            )}

            {showModal && userData && (
                <BuyCreditsModal
                    show={showModal}
                    handleClose={() => setShowModal(false)}
                    userDetail={userData}
                />
            )}
        </>
    );
}

export const MultimodalInput = memo(
    PureMultimodalInput,
    (prevProps, nextProps) => {
        if (prevProps.input !== nextProps.input) return false;
        if (prevProps.aiLimit !== nextProps.aiLimit) return false;
        if (prevProps.status !== nextProps.status) return false;
        if (prevProps.selectedVisibilityType !== nextProps.selectedVisibilityType)
            return false;
        return true;
    }
);

function PureStopButton({
    stop,
    setMessages,
}) {
    return (
        <Button
            data-testid="stop-button"
            className="rounded-full p-1.5 h-fit border dark:border-zinc-600"
            onClick={(event) => {
                event.preventDefault();
                stop();
                setMessages((messages) => messages);
            }}
        >
            <StopIcon size={14} />
        </Button>
    );
}

const StopButton = memo(PureStopButton);

function PureSendButton({
    submitForm,
    input,
    uploadQueue,
    disabled,
}) {
    const dispatch = useDispatch();
    return (
        <Button
            id="sendBtn"
            data-testid="send-button"
            className="rounded-full p-1.5 h-fit border dark:border-zinc-600 !bg-white !text-black hover:!bg-black hover:!text-white rounded-full cursor-pointer"
            disabled={disabled || !input.trim()}
            onClick={(event) => {
                event.preventDefault();
                dispatch(setActiveNavItem("z-[46]"));
                submitForm();
                dispatch(setActiveNavItem("z-[46]"));
            }}
        >
            <ArrowUpIcon size={14} />
        </Button>
    );
}

const SendButton = memo(PureSendButton, (prevProps, nextProps) => {
    if (prevProps.disabled !== nextProps.disabled) return false;
    if (prevProps.input !== nextProps.input) return false;
    if (prevProps.submitForm !== nextProps.submitForm) return false; // add this
    return true;
});
